import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { DASHBOARD_KPIS } from "../../utils/Constant";
//import { isTokenValid } from "../../utils/jwtUtils";

function Home() {
  const navigate = useNavigate();
  const authToken = useSelector((state) => state.token);
  const [dashboardData, setDashboardData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // if (!isTokenValid(authToken.token)) {
        //   console.log("Token expired");
        //   throw new Error("Authentication token is not valid or has expired");
        // }
        if (!authToken) {
          navigate('/login');
          //throw new Error("Authentication token not found");
        }


        const response = await axios.get(DASHBOARD_KPIS, {
          headers: {
            Authorization: `Bearer ${authToken.token}`,
          },
        });
        setDashboardData(response.data.data);
      } catch (error) {
        setError(error.message || "Failed to fetch dashboard data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authToken]);

  const renderContent = (value, label, link, dataValue) => {
    return (
      <div className="col-lg-3 col-6">
        <div className={`small-box ${value}`}>
          {loading ? (
            <div
              className="col-lg-12 col-sm-12 main-heading"
              style={{ textAlign: "center" }}
            >
              <div
                className="spinner-border"
                style={{
                  width: "4rem",
                  height: "4rem",
                  color: "#c21557",
                  textAlign: "center",
                }}
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <div className="inner">
                <h3>{dataValue ? dataValue : "0"}</h3>
                <p>{label}</p>
              </div>
              <div className="icon">
                <i className={`ion ion-${value}`} />
              </div>
            </>
          )}
          <a href={link} className="small-box-footer">
            More info <i className="fas fa-arrow-circle-right" />
          </a>
        </div>
      </div>
    );
  };

  return (
    <DashboardLayout>
      <div>
        <div className="row">
          {renderContent("bg-info", "New Bids", "/bids/list", dashboardData && dashboardData.bids.ongoingBids)}
          {renderContent("bg-success", "Total Products", "/products/list", dashboardData && dashboardData.totalProducts)}
          {renderContent("bg-warning", "Total Customers", "/users/list", dashboardData && dashboardData.totalUsers)}
          {renderContent("bg-danger", "Total Orders", "/orders/list", dashboardData && dashboardData.orders.totalOrders)}
        </div>
      </div>
    </DashboardLayout>
  );
}

export default Home;
